import { gql } from '@apollo/client';
const REMOVE_TENANT_ORDER_OPERATOR = gql `
  mutation RemoveOrderOperator($orderOperatorId: ID!) {
    removeOrderOperator(orderOperatorId: $orderOperatorId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_ORDER_OPERATOR;
